import map from "lodash/map";
import * as awsTranscribeSdk from "@aws-sdk/client-transcribe-streaming";
import logger from "./Logger";
import { CONST } from "./const";

const client = new awsTranscribeSdk.TranscribeStreaming({
  region: "ap-southeast-1",
  credentials: {
    accessKeyId: CONST.AWS_ACCESS_KEY_ID || "",
    secretAccessKey: CONST.AWS_SECRET_ACCESS_KEY || "",
  },
});

export async function* startStreamTranscription({
  lang,
  sampleRate,
  audioStream,
}: {
  lang: string;
  sampleRate: number;
  audioStream: () => AsyncIterable<awsTranscribeSdk.AudioStream>;
}): AsyncGenerator<string> {
  let isPartial = true;
  let data = null;
  let langArray = lang.split(",");

  if (langArray.length > 1) {
    data = await client.startStreamTranscription({
      AudioStream: audioStream(),
      MediaEncoding: awsTranscribeSdk.MediaEncoding.PCM,
      MediaSampleRateHertz: sampleRate,
      IdentifyLanguage: true,
      LanguageOptions: lang,
    });
  } else {
    data = await client.startStreamTranscription({
      AudioStream: audioStream(),
      MediaEncoding: awsTranscribeSdk.MediaEncoding.PCM,
      MediaSampleRateHertz: sampleRate,
      LanguageCode: lang as awsTranscribeSdk.LanguageCode,
    });
  }

  for await (const event of data.TranscriptResultStream ?? []) {
    if (event.TranscriptEvent) {
      const results = event.TranscriptEvent.Transcript?.Results ?? [];

      const transcripts = map(results, (result) => {
        isPartial = result.IsPartial ?? false;
        logger.debug(isPartial);
        return map(result.Alternatives ?? [], (alternative) => {
          return alternative.Transcript;
          // return map(alternative.Items ?? [], (item) => {
          //   return item.Content;
          // }).join(' ');
        }).join(" ");
      });

      for (const transcript of transcripts) {
        if (!isPartial) yield transcript;
      }
    }
  }
}
